import React from 'react';

const Footer = () => {
    return (
        <footer className="bg-[#1a1a1a] text-white py-4">
            <div className="container mx-auto px-6 md:px-12 text-center text-gray-400">
                <p className="text-xs tracking-wider">
                    © 2021 by DBQ Technologies Pvt. Ltd.
                </p>
            </div>
        </footer>
    );
};

export default Footer;

